export default __webpack_public_path__ + "static/media/favicon.dea5f072.svg";